/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { LuArrowUpRight } from "react-icons/lu";
import { MdContentCopy, MdDeleteForever } from "react-icons/md";
import { BiEdit, BiPowerOff } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { deleteChatBoot, getAllChatbotUser, getChatbootUserByID, getMarkAschatBoot, InsertChatboot } from "../../Redux/ChatSlice";
import sweetAlert from "../Common/sweetAlert";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { formatDate } from "../Common/Common";
import Loading from "../Common/Loading";
import SetupChatbot from "./Chatbot_Setup";
import toast from "react-hot-toast";
import Pagination from "../Common/Pagination";
import { getMenuAll, getMenuPermission } from "../../Redux/SideBarSlice";

// shraddha
const ChatBot = ({ isVisible, setIsVisible, setSidebarOpen, sidebarOpen, isDark, setIsDark }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const ChatStore = useSelector((state) => state?.root?.Chat)
    const { user } = useSelector((state) => state.root.auth);

    const [activeTab, setActiveTab] = useState("dashboard");
    const [loading, setLoading] = useState(true);
    const [loadFrist, setloadFrist] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = ChatStore?.getAllchatUser?.slice(indexOfFirstRow, indexOfLastRow)
    const totalPages = Math.ceil(ChatStore?.getAllchatUser?.length / rowsPerPage);
    const [permissions, setPermissions] = useState({
        isDelete: false,
        isSave: false,
        isView: false,
    });

    useEffect(() => {
        dispatch(getMenuAll()).then((item) => {
            const findData = item?.payload?.data?.menu.reduce((result, menuItem) => {
                if (menuItem?.submenu && Array.isArray(menuItem?.submenu)) {
                    const submenuItem = menuItem?.submenu?.find((submenuItem) => submenuItem?.pageName === "Chatbot");
                    if (submenuItem) { result = submenuItem; }
                }
                return result;
            }, null);

            if (findData) {
                const ItemID = findData?.moduleID;
                const payload = { UserRoleID: user?.userRoleID, ModuleID: ItemID };
                dispatch(getMenuPermission(payload)).then((permissionItem) => {
                    if (Array.isArray(permissionItem?.payload?.data) && permissionItem?.payload?.data?.length > 0) {
                        setPermissions(permissionItem?.payload?.data[0]);
                    }
                });
            }
        });
    }, []);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };
    useEffect(() => {
        if (loadFrist) {
            setLoading(true)
            dispatch(getAllChatbotUser({}))
                .then((res) => {
                    const timer = setTimeout(() => {
                        setLoading(false)
                    }, 1000);

                    return () => clearTimeout(timer);

                }).catch((error => {
                    setLoading(false)
                    console.log('error :>> ', error);
                }))
            setloadFrist(false)
        }
    }, [dispatch, loadFrist, ChatStore]);

    const handleTabClick = (tabId) => { setActiveTab(tabId); };

    const DeactiveChatBoot = (item) => {
        const payload = {
            ChatbotID: item?.chatbotID,
            Isactive: item?.isactive ? false : true,
        };

        dispatch(getMarkAschatBoot(payload)).then((res) => {
            if (res) {
                dispatch(getAllChatbotUser({}))
            }
        })
    }

    const DeleteChatBoot = async (id) => {
        try {
            const result = await sweetAlert.confirm(
                "Are you sure?",
                "You won't be able to revert this!"
            );

            if (result.isConfirmed) {
                await dispatch(deleteChatBoot(id)).then((res) => {
                    if (res.payload.status === true) {
                        setloadFrist(true);
                    }
                });
                sweetAlert.success("Deleted successfully");
            }
        } catch (error) {
            console.error("Error:", error);
            sweetAlert.error("An error occurred");
        }
    };

    const handlerInsertChatBoot = async (returndata) => {
        const Payload = {
            ...returndata,
            chatbotID: 0,
            conversationID: 0,
            name: `${returndata?.name} Copy`,
        }

        const response = await dispatch(InsertChatboot(Payload))
        toast.remove()
        if (response) {
            setloadFrist(true)
            toast.success('ChatBot Duplicate Successfully!')
        }
    }

    const DuplicatechatBot = async (id) => {
        await dispatch(getChatbootUserByID(id)).then((res) => {
            const returndata = res?.payload?.data
            if (returndata) handlerInsertChatBoot(returndata)
        }).catch((error) => {
            console.log('error :>> ', error);
        })
    }

    const totalChatbots = ChatStore?.getAllchatUser?.length || 0;
    const activeChatbots = ChatStore?.getAllchatUser?.filter(c => c?.isactive).length || 0;
    const inactiveChatbots = ChatStore?.getAllchatUser?.filter(c => !c?.isactive).length || 0;
    const totalViews = ChatStore?.getAllchatUser?.reduce((sum, c) => sum + (c?.viewed || 0), 0) || 0;
    const totalClicks = ChatStore?.getAllchatUser?.reduce((sum, c) => sum + (c?.clicked || 0), 0) || 0;
    const avgCtr = ChatStore?.getAllchatUser?.length ? (ChatStore?.getAllchatUser?.reduce((sum, c) => sum + (c?.clicked || 0), 0) / ChatStore?.getAllchatUser?.reduce((sum, c) => sum + Math.max(1, c?.viewed || 0), 0) * 100).toFixed(1) : 0;

    return (
        <>
            <div className="flex flex-1">
                <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">
                    {loading && (<div className="h-screen"><Loading /></div>)}
                    {!loading && (
                        <>
                            {/* Page Header */}
                            <div className="crm-page-header">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <h1 className="crm-page-title">Chatbot</h1>
                                        <ol className="crm-breadcrumb">
                                            <li><a href="/Analytics">Disploy</a></li>
                                            <li>/</li>
                                            <li>Leads</li>
                                            <li>/</li>
                                            <li className="active">Chatbot</li>
                                        </ol>
                                    </div>
                                    {permissions?.isSave && (
                                        <button className="crm-new-btn" onClick={() => navigate("/ChatBot/create")}>
                                            <FaPlus size={11} />
                                            New Playbook
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

                                {/* Stat Cards */}
                                <div className="crm-stats-row">
                                    <div className="crm-stat-card crm-card-indigo">
                                        <div className="flex items-start gap-3">
                                            <div className="stat-icon stat-icon-indigo">
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <rect x="2" y="3" width="20" height="14" rx="2" />
                                                    <path d="M8 21h8M12 17v4" />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="stat-label">Total Playbooks</p>
                                                <p className="stat-value">{totalChatbots}</p>
                                                <p className="stat-trend-up">↑ 5% vs last month</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="crm-stat-card crm-card-green">
                                        <div className="flex items-start gap-3">
                                            <div className="stat-icon stat-icon-green">
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <circle cx="12" cy="12" r="10" />
                                                    <polyline points="12 6 12 12 16 14" />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="stat-label">Active Bots</p>
                                                <p className="stat-value">{activeChatbots}</p>
                                                <p className="stat-trend-up">↑ 8% vs last month</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="crm-stat-card crm-card-red">
                                        <div className="flex items-start gap-3">
                                            <div className="stat-icon stat-icon-red">
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <circle cx="12" cy="12" r="10" />
                                                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="stat-label">Inactive Bots</p>
                                                <p className="stat-value">{inactiveChatbots}</p>
                                                <p className="stat-trend-down">↓ 1% vs last month</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="crm-stat-card crm-card-blue">
                                        <div className="flex items-start gap-3">
                                            <div className="stat-icon stat-icon-blue">
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="stat-label">Total Views</p>
                                                <p className="stat-value">{totalViews}</p>
                                                <p className="stat-trend-up">↑ 12% vs last month</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="crm-stat-card crm-card-orange">
                                        <div className="flex items-start gap-3">
                                            <div className="stat-icon stat-icon-orange">
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <circle cx="12" cy="12" r="10" />
                                                    <path d="M12 6v6l4 2" />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="stat-label">Total Clicks</p>
                                                <p className="stat-value">{totalClicks}</p>
                                                <p className="stat-trend-up">↑ 15% vs last month</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="crm-stat-card crm-card-sky">
                                        <div className="flex items-start gap-3">
                                            <div className="stat-icon stat-icon-sky">
                                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                                                    <polyline points="17 6 23 6 23 12" />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="stat-label">Avg CTR</p>
                                                <p className="stat-value">{avgCtr}%</p>
                                                <p className="stat-trend-up">↑ 4% vs last month</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="crm-panel p-5">
                                    {!loading && ChatStore?.getAllchatUser.length === 0 ? (<SetupChatbot />) : (
                                        <>
                                            <div className="flex-auto">
                                                <div className="border-b border-gray-200 dark:border-gray-700 mb-4 flex justify-between">
                                                    <ul
                                                        className="flex flex-wrap-mb-px"
                                                        id="myTab"
                                                        role="tablist"
                                                    >
                                                        <li className="mr-2" role="presentation">
                                                            <button
                                                                className={`inline-block text-gray-500 hover:text-gray-600 hover:border-gray-300 rounded-t-lg py-4 px-4 text-sm font-medium text-center border-transparent border-b-2 dark:text-gray-400 dark:hover:text-gray-300 ${activeTab === "dashboard"
                                                                    ? "border-gray-300"
                                                                    : ""
                                                                    }`}
                                                                id="playbooks-tab"
                                                                onClick={() => handleTabClick("dashboard")}
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="dashboard"
                                                                aria-selected={activeTab === "dashboard"}
                                                            >
                                                                Playbooks
                                                            </button>
                                                        </li>
                                                        <li className="mr-2" role="presentation">
                                                            <button
                                                                className={`inline-block text-gray-500 hover:text-gray-600 hover:border-gray-300 rounded-t-lg py-4 px-4 text-sm font-medium text-center border-transparent border-b-2 dark:text-gray-400 dark:hover:text-gray-300 ${activeTab === "settings"
                                                                    ? "border-gray-300"
                                                                    : ""
                                                                    }`}
                                                                id="settings-tab"
                                                                onClick={() => handleTabClick("settings")}
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="settings"
                                                                aria-selected={activeTab === "settings"}
                                                            >
                                                                Settings
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>

                                                {!loading && activeTab === "dashboard" && (
                                                    <div
                                                        className="bg-gray-50 rounded-lg dark:bg-gray-800"
                                                        id="dashboard"
                                                        role="tabpanel"
                                                        aria-labelledby="playbooks-tab"
                                                    >
                                                        <div>
                                                            <div className="relative scroll-inner mb-4">
                                                                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className="p-3 text-left">
                                                                               Active Playbooks
                                                                            </th>
                                                                            <th scope="col" className="p-3">
                                                                                Views
                                                                            </th>
                                                                            <th scope="col" className="p-3">
                                                                                Clicked
                                                                            </th>
                                                                            <th scope="col" className="p-3">
                                                                                Qualified
                                                                            </th>
                                                                            <th scope="col" className="p-3">
                                                                                Disqualified
                                                                            </th>
                                                                            <th scope="col" className="p-3">
                                                                                Status
                                                                            </th>
                                                                            <th scope="col" className="p-3 text-center">
                                                                                Action
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            currentRows?.length > 0 ? (currentRows?.map((item, index, arr) => {
                                                                                const showUpward = index >= arr.length - 2 && arr.length > 1;
                                                                                return (
                                                                                <tr key={index} className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-left" >
                                                                                    <td className="p-3 font-medium whitespace-nowrap text-left"
                                                                                    >
                                                                                        <h3 onClick={() => navigate(`/ChatBot/create/${item?.chatbotID}`)}><a className="text-indigo-600 hover:text-indigo-800 cursor-pointer font-semibold">{item?.name}</a></h3>
                                                                                        <p className="text-xs text-slate-500">Owner <span className="mx-2"> | </span>Created On {formatDate(item?.createdOn)} </p>
                                                                                    </td>
                                                                                    <td className="p-3 text-sm text-slate-600 text-left">
                                                                                        {item?.viewed}
                                                                                    </td>
                                                                                    <td className="p-3 text-sm text-slate-600 text-left">
                                                                                        {item?.clicked}
                                                                                    </td>
                                                                                    <td className="p-3 text-sm text-slate-600 text-left">
                                                                                        0
                                                                                    </td>
                                                                                    <td className="p-3 text-sm text-slate-600 text-left">
                                                                                        0
                                                                                    </td>
                                                                                    <td className="p-3 text-sm text-left">
                                                                                        <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${item?.isactive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>{item?.isactive ? 'ACTIVE' : 'INACTIVE'}</span>
                                                                                    </td>
                                                                                    <td className="p-3 text-center whitespace-nowrap">
                                                                                        <div className="relative inline-block text-left">
                                                                                            <button
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    setOpenActionMenuId(openActionMenuId === item.chatbotID ? null : item.chatbotID);
                                                                                                }}
                                                                                                className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                                                                            >
                                                                                                <BsThreeDotsVertical size={16} />
                                                                                            </button>
                                                                                            {openActionMenuId === item.chatbotID && (
                                                                                                <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                                                                    {permissions?.isSave && (
                                                                                                        <button
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                navigate(`/ChatBot/create/${item?.chatbotID}`);
                                                                                                                setOpenActionMenuId(null);
                                                                                                            }}
                                                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                                                        >
                                                                                                            <BiEdit size={14} className="text-indigo-500" />
                                                                                                            <span>Edit</span>
                                                                                                        </button>
                                                                                                    )}
                                                                                                    <button
                                                                                                        onClick={(e) => {
                                                                                                            e.stopPropagation();
                                                                                                            DuplicatechatBot(item?.chatbotID);
                                                                                                            setOpenActionMenuId(null);
                                                                                                        }}
                                                                                                        className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                                                    >
                                                                                                        <MdContentCopy size={14} className="text-indigo-500" />
                                                                                                        <span>Copy</span>
                                                                                                    </button>
                                                                                                    <button
                                                                                                        onClick={(e) => {
                                                                                                            e.stopPropagation();
                                                                                                            DeactiveChatBoot(item);
                                                                                                            setOpenActionMenuId(null);
                                                                                                        }}
                                                                                                        className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                                                    >
                                                                                                        <BiPowerOff size={14} className="text-indigo-500" />
                                                                                                        <span>{item?.isactive ? 'Deactivate' : 'Activate'}</span>
                                                                                                    </button>
                                                                                                    {permissions?.isDelete && (
                                                                                                        <button
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                DeleteChatBoot(item?.chatbotID);
                                                                                                                setOpenActionMenuId(null);
                                                                                                            }}
                                                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors text-left"
                                                                                                        >
                                                                                                            <MdDeleteForever size={14} className="text-red-500" />
                                                                                                            <span>Delete</span>
                                                                                                        </button>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                             ); })) :
                                                                                (<tr>
                                                                                    <td colSpan={7} className="text-center py-4 text-slate-500">
                                                                                        Not Found.
                                                                                    </td>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <Pagination setCurrentPage={setCurrentPage} handlePageChange={handlePageChange} currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={ChatStore?.getAllchatUser?.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} name='ChatBots' />

                                                        </div>

                                                    </div>
                                                )}
                                                {activeTab === "settings" && (
                                                    <div
                                                        className="bg-gray-50 rounded-lg dark:bg-gray-800"
                                                        id="settings"
                                                        role="tabpanel"
                                                        aria-labelledby="settings-tab"
                                                    >
                                                        <div className="flex-auto p-4">
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="switch-1"
                                                                    className="hidden"
                                                                />
                                                                <label
                                                                    for="switch-1"
                                                                    id="switch_1"
                                                                    className="custom-switch relative border border-slate-300 mr-2 w-8 h-4 rounded-full bg-slate-50 dark:bg-slate-700 dark:border-slate-600 cursor-pointer"
                                                                ></label>
                                                                <label
                                                                    for="switch-1"
                                                                    className="dark:text-slate-400"
                                                                >
                                                                    Track and save the chat conversion URL
                                                                </label>
                                                            </div>
                                                            <p>
                                                                You can track the specific page that your customer
                                                                was on when the lead converted. A new custom field
                                                                “Chat conversion URL” will be automatically added
                                                                to store this information.
                                                            </p>
                                                            <p>
                                                                <a href="#" className="text-blue-500 text-xl">
                                                                    Learn more about custom fields Customize your
                                                                    own chatbot and start capturing leads today
                                                                    <LuArrowUpRight className="text-3xl" />
                                                                </a>
                                                            </p>
                                                        </div>
                                                        <div className="flex-auto p-4">
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="switch-2"
                                                                    className="hidden"
                                                                    checked=""
                                                                />
                                                                <label
                                                                    for="switch-2"
                                                                    id="switch_2"
                                                                    className="custom-switch switch-green relative border  border-slate-300 mr-2 w-8 h-4 rounded-full bg-slate-50 dark:bg-slate-700 dark:border-slate-600 cursor-pointer"
                                                                ></label>
                                                                <label
                                                                    for="switch-2"
                                                                    className="dark:text-slate-400"
                                                                >
                                                                    Capture unfinished conversation details
                                                                </label>
                                                            </div>
                                                            <p>
                                                                You can capture the provided contact details
                                                                (email and phone number) even when the
                                                                conversation hasn't been finished
                                                            </p>
                                                            <p>
                                                                Save location: Leads Owner: bhavesh ·{" "}
                                                                <a
                                                                    href="#"
                                                                    className="focus:outline-none text-[11px] bg-primary-500/10 text-primary-500 dark:text-primary-600 rounded font-medium py-[2px] px-2"
                                                                >
                                                                    Edit
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default ChatBot;

